import findIndex from 'lodash/findIndex';
import max from 'lodash/max';
import pull from 'lodash/pull';

type ListingWithId = {
  maloneLotIdEncoded?: string;
  aliasEncoded?: string;
};

const getListingIdentifier = (listing: ListingWithId | null | undefined): string | null => {
  if (!listing) {
    return null;
  }

  return listing.maloneLotIdEncoded || listing.aliasEncoded || null;
};

const findListingIndex = (listingGroups: Array<ListingWithId>, listing: ListingWithId): number => {
  const listingId = getListingIdentifier(listing);

  if (!listingId) {
    return -1;
  }

  return findIndex(listingGroups, (currentListing) => {
    return getListingIdentifier(currentListing) === listingId;
  });
};

// same as above but will return 0 if it does not find an index instead of -1
const getCurrentListingIndex = (list: Array<ListingWithId>, currentListing: ListingWithId): number => {
  return max([findListingIndex(list, currentListing), 0]) as number;
};

const updateUserItemTypes = (
  userItemTypes: Array<string> | null | undefined,
  action: string,
  type: string,
): Array<string> => {
  const nextUserItemTypes = userItemTypes ? [...userItemTypes] : [];

  if (action === 'add') {
    if (nextUserItemTypes.indexOf(type) === -1) {
      nextUserItemTypes.push(type);
    }
  } else {
    pull(nextUserItemTypes, type);
  }

  return ([] as Array<string>).concat(nextUserItemTypes);
};

export { findListingIndex, updateUserItemTypes, getCurrentListingIndex, getListingIdentifier };
